export default __webpack_public_path__ + "de4aaef354a74df1e11e6b6c47408c12.gif";